import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = ({ title, text, buttonText, buttonLink }) => {
  return (
    <div className="cta-container" style={{ padding: '40px 20px', backgroundColor: '#EBDAFF', textAlign: 'center' }}>
      <h2>{title}</h2>
      <p>{text}</p>
      <Link to={buttonLink} style={{ padding: '10px 20px', background: '#6C63FF', color: 'white', textDecoration: 'none', borderRadius: '5px' }}>
        {buttonText}
      </Link>
    </div>
  );
};

export default CallToAction;